/**
 * Class Dialog
 *
 * @author Jeremie Nogues
 * @year 2024
 * @filename dialog.js
 * @location /js/my
 */

export default class Dialog {
	/**
	 * Constructor
	 */
	constructor() {
		this.id = "";
	}
	/**
	 * Initialise l'id du dialog
	 * 
	 * @param {string} id -> id du dialog
	 */
	setId(id) {
		this.id = id;
	}
	/**
	 * Récupère l'id du dialog
	 */
	getId() {
		return this.id;
	}
	/**
	 * Création d'une fenêtre de dialog
	 * 
	 * @param {string} titre -> titre du dialog
	 * @param {bool} boutons -> boutons ou pas
	 */
	create(titre, boutons = true) {

		//div principale
		const div_principale = document.createElement("div");
		div_principale.id = this.id;
		div_principale.className = "dialog";

		//div content
		const div_content = document.createElement("div");
		div_content.className = "dialog-content";

		//div titre
		const div_title = document.createElement("div");
		div_title.className = "dialog-title";
		div_title.innerHTML = "<b>" + titre + "</b>" + "<div class='dialog-close'></div>";
		div_content.appendChild(div_title);

		//div message
		const div_message = document.createElement("div");
		div_message.className = "dialog-message";
		div_content.appendChild(div_message);

		//s'il faut créer des boutons
		if (boutons) {
			this.createButtons(div_content);
		}

		//ajoute le dialog à la page
		div_principale.appendChild(div_content);
		document.body.appendChild(div_principale);

		//action sur le bouton close
		div_title.querySelector(".dialog-close").addEventListener("click", () => this.hide());
	}
	/**
	 * Création des boutons
	 * 
	 * @param {div} container -> container des boutons
	 */
	createButtons(container) {

		//création des boutons
		const div_boutons = document.createElement("div");
		div_boutons.className = "dialog-boutons";

		//création du bouton enregistrer
		const valideBtn = document.createElement("button");
		valideBtn.type = "button";
		valideBtn.id = this.id + "_valider";
		valideBtn.innerHTML = "<span class='icone-valide'></span> Valider";
		div_boutons.appendChild(valideBtn);

		//création du bouton annuler
		const cancelBtn = document.createElement("button");
		cancelBtn.type = "button";
		cancelBtn.id = this.id + "_annuler";
		cancelBtn.innerHTML = "<span class='icone-delete'></span> Annuler";
		cancelBtn.onclick = () => {
			this.hide();
		};
		div_boutons.appendChild(cancelBtn);

		//ajoute la div au container
		container.appendChild(div_boutons);
	}
	/**
	 * Impose la width
	 * 
	 * @param {int} width -> width en pixels
	 */
	setWidth(width) {
		document.querySelector("#" + this.id + " .dialog-content").style.width = width + "px";
	}
	/**
	 * Mise à jour du titre
	 * 
	 * @param {string} titre -> titre du dialog
	 */
	updateTitle(titre) {
		document.querySelector("#" + this.id + " .dialog-title b").innerHTML = titre;
	}
	/**
	 * Mise à jour du contenu
	 * 
	 * @param {string} content -> contenu
	 */
	updateContent(content) {
		document.querySelector("#" + this.id + " .dialog-message").appendChild(content);
	}
	/**
	 * Affiche le dialog
	 */
	show() {
		document.getElementById(this.id).style.display = "flex";
	}
	/**
	 * Cache le dialog
	 */
	hide() {
		//ferme le dialog
		document.getElementById(this.id).style.display = "none";

		//reactive le bouton de confirmation
		const bouton = document.getElementById(this.id + "_valider");
		if (bouton) {
			const html = bouton.innerHTML.split("</span>");
			bouton.innerHTML = "<span class='icone-valide'></span>" + html[1];
			bouton.disabled = false;
		}
	}
	/**
	 * Cache la croix pour fermer
	 */
	hideClose() {
		document.querySelector("#" + this.id + " .dialog-close").style.display = "none";
	}
}